import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';

import { AlertComponent } from './alert.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatIconModule
  ],
  exports: [
    AlertComponent
  ],
  providers: [
  ],
  declarations: [
    AlertComponent
  ]
})
export class AlertModule { }
